import { render, staticRenderFns } from "./daily-cargo-edit-driver-administration.vue?vue&type=template&id=5626569c"
import script from "./daily-cargo-edit-driver-administration.vue?vue&type=script&lang=js"
export * from "./daily-cargo-edit-driver-administration.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-edit-driver-administration.vue?vue&type=style&index=0&id=5626569c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports